import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import {Grid} from 'react-bootstrap';
import { not } from 'ramda';

import Breadcrumbs from 'system/breadcrumbs';
import {Wrapper} from 'system/wrapper';
import Cards from 'system/cards';
import { Li } from 'system/cards/components';
import Pagination from 'pagination';

import communities from 'images/information-center/communities.svg';

import PropTypes from 'prop-types';

import Spinner from 'spinner';

import {loadInstitutionByType} from 'redux/actions/portal/institutions';


const mapStateToProps = (state) => ({
  institutions: state.institutions.get('institutionsList'),
  isFetching: state.institutions.get('institutionsIsLoading'),
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (offset) => dispatch(loadInstitutionByType( '02', 12, offset))
});


class Communities extends Component {

  renderDefaultImage = photo => not(photo) && <img src={communities} alt="hospital"/>;

  componentDidMount() {
    this.props.onLoad();
  }

  render() {

    if (this.props.institutions === undefined) {
      return (
        <Wrapper>
          <Spinner />
        </Wrapper>
      )
    }

    return(
      <div>
        <Breadcrumbs>
                <li><Link to="/">Головна</Link></li>
                <li><Link to="/infocenter">Інфоцентр</Link></li>
                <li><Link to="/infocenter/communities">Громадські організації</Link></li>
          </Breadcrumbs>
        <Wrapper>
          <Grid>
          <h2>Громадські організації</h2>
            {this.props.isFetching ? (
              <Spinner />
            ):(
              <Cards>
                {this.props.institutions.get('results').map((item, i) => (
                  <Li key={i} img={item.get('photo')}>
                    <Link to={`/infocenter/communities/detail/${item.get('id')}`}>
                      {this.renderDefaultImage(item.get('photo'))}
                      <div>
                        <h3>{item.get('full_title')}</h3>
                        <p>{item.get('address')}</p>
                      </div>
                    </Link>
                  </Li>
                ))}
              </Cards>
            )}
            <Pagination counts={this.props.institutions.get('count')} path={`/institutions/`} matched={this.props.match.params.page} limits={12} />
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

Communities.propTypes = {
  isFetching: PropTypes.bool,
  onLoad: PropTypes.func
}

export default  withRouter(connect(mapStateToProps, mapDispatchToProps)(Communities));



// WEBPACK FOOTER //
// ./src/system/information-center/communities/index.js